import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Moment from 'react-moment';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getOperadorEmpresa,
    getOperadorRemarcacao,
    getGestorOperacoes,
    getVendedorAgencia,    
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';
import { buscarReservasItinerario } from '../../actions/reserva/buscarReservasItinerario';
import buscarLocalizacaoVeiculo from '../../actions/veiculo/buscarLocalizacaoVeiculo';
import $ from 'jquery';
import iconeQrCode from '../../img/codigo-qr.png'
import iconeTransferencia from '../../img/transferindo.png'
import iconeEncomenda from '../../img/icone-encomenda.png';
import iconeCash from '../../img/cash-coin.svg'
import { ativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import buscarPrecosRota from '../../actions/preco/buscarPrecosRota';
import selecionarRota from '../../actions/rota/selecionarRota';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import { ativarVendaSite } from '../../actions/itinerario/ativarOuInativarVendaSite'
import { EMPRESA_POLITUR, listaTipoPrecos, tipoCategoria } from '../../util/constantsUtil';
import ReactTooltip from 'react-tooltip';
import iconAudoria from  '../../img/auditoria.png';
import iconHistoricoTransferencia from '../../img/transferencia-de-passageiros.png';
import buscarUltimosHistoricosItinerario from '../../actions/itinerario/buscarUltimosHistoricosItinerario';
import buscarHistoricosTransferenciaPassageiros from '../../actions/itinerario/buscarHistoricosTransferenciaPassageiros';

export class Itinerario extends React.Component {

    selecionarItinerario(itinerario) {
        this.props.changeFieldValue('formularioCadastroItinerario',
            'idItinerario', itinerario.id);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'dataPartida', moment(itinerario.dataPartida)
                .toDate());
        this.props.changeFieldValue('formularioCadastroItinerario',
            'horaSaida', itinerario.horaSaida);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'assentosDisponiveis', itinerario.assentosDisponiveis);

        if (itinerario.tipoPreco) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoPrecoPrimeiroAndar', {
                label: itinerario.tipoPreco.descricaoTipoPreco,
                value: itinerario.tipoPreco.tipoPreco
            });
        }

        if(itinerario.descontoMaximo !== null){
            this.props.changeFieldValue('formularioCadastroItinerario',
            'descontoMaximo', itinerario.descontoMaximo);

        }

        if (itinerario.tipoAjusteItinerario !== null) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoAjusteItinerario', {
                label: itinerario.tipoAjusteItinerario.descricao,
                value: itinerario.tipoAjusteItinerario.nameEnum
            });
            if (itinerario.tipoConfiguracaoPreco) {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'tipoConfiguracaoPreco', {
                    label: itinerario.tipoConfiguracaoPreco.descricao,
                    value: itinerario.tipoConfiguracaoPreco.valor
                });
            }            
            if (itinerario.valorAjuste != null) {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'exibirAjuste', true);
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'valorAjuste', itinerario.valorAjuste ? itinerario.valorAjuste : '00.00');

            }            
            if (itinerario.horaPartidaRegra != null) {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'horaPartidaRegra', itinerario.horaPartidaRegra);
            }
            this.props.changeFieldValue('formularioCadastroItinerario',
                'quantidadePoltronasRegra', itinerario.quantidadePoltronasRegra);

            
        }

        if (itinerario.tipoConfiguracaoPrecoPrioritario != null && itinerario.pricePorUsuario && itinerario.pricePorUsuario.length) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoConfiguracaoPrecoPrioritario', {
                label: itinerario.tipoConfiguracaoPrecoPrioritario.descricao,
                value: itinerario.tipoConfiguracaoPrecoPrioritario.valor
            });            
            if (itinerario.tipoConfiguracaoPrecoPrioritario.valor === 'POR_USUARIO') {
                this.props.changeFieldValue('formularioCadastroItinerario',
                    'exibirAjustePrioritario', true);                

            }
            this.props.changeFieldValue('formularioCadastroItinerario',
                'tipoConfiguracaoPrecoPrioritario', {
                label: itinerario.tipoConfiguracaoPrecoPrioritario.descricao,
                value: itinerario.tipoConfiguracaoPrecoPrioritario.valor
            });
            
            if (itinerario.pricePorUsuario != null && itinerario.tipoConfiguracaoPrecoPrioritario.valor === 'POR_USUARIO') {                
                this.props.preencherPricePorUsuario(itinerario.pricePorUsuario.map(it => {
                    const vendedor = this.props.usuariosVendedores.find(v => v.chave == it.usuarioId)
                    return {
                        id: it.usuarioId,
                        tipoAjusteItinerario: {label: it.tipoAjusteItinerario.descricao, value: it.tipoAjusteItinerario.nameEnum},
                        valorAjuste: it.valorAjuste,
                        vendedor: {label: vendedor.valor, value: vendedor.chave }
                    }
                }));
                
            }
        }

        if (itinerario.prestador) {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'prestador', {
                label: itinerario.prestador.valor,
                value: itinerario.prestador.chave
            });
        } else {
            this.props.changeFieldValue('formularioCadastroItinerario',
                'prestador', {
                label: 'Frota própria',
                value: null
            });
        }



        this.props.changeFieldValue('formularioCadastroItinerario',
            'veiculo', {
            label: `${itinerario.veiculoDto.descricao}`,
            value: itinerario.veiculoDto
        });
        this.props.changeFieldValue('formularioCadastroItinerario',
            'habilitadoSite', itinerario.habilitadoSite);

        this.props.preencherModalEdicao(this.props.itinerario);
        this.props.selecionarItinerario(this.props.itinerario);

    }

    selecionarItinerarioAlterarVeiculo(itinerario) {
        this.props.selecionarItinerario(this.props.itinerario);
        this.props.changeFieldValue('formularioCadastroItinerario',
            'idItinerario', itinerario.id);
        this.props.changeFieldValue('formularioAlterarVeiculoItinerario',
            'veiculo', {
            label: `${itinerario.veiculoDto.descricao}`,
            value: itinerario.veiculoDto
        });
        if (itinerario.veiculoDto.seDoisAndares) {
            this.props.changeFieldValue('formularioAlterarVeiculoItinerario',
                'andar', {
                label: `${itinerario.andar === 1 ? '1º Andar' : '2º Andar'}`,
                value: itinerario.andar
            })
        }
    }

    ativarOuInativar = (e) => {
        const idItinerario = this.props.itinerario.id;
        const idEmpresa = this.props.itinerario.idEmpresa;
        if (e.target.value != 'false') {
            this.props.itinerarioChecked(idItinerario);
            $('#modalConfirmacaoInativacaoItinerario').modal({
                show: true
            });
        } else {
            this.props.ativarItinerario(idEmpresa, idItinerario)
                .then(() => {
                    this.props.buscarItinerarios();
                });
        }
    }

    exibeAtivo = () => {
        return (
            <input type="checkbox" data-target="#modalConfirmacaoInativacaoItinerario" value={this.props.itinerario.ativo} checked={this.props.itinerario.ativo} onChange={this.ativarOuInativar} />
        );
    }

    exibirStatus() {
        if (this.props.itinerario.ativo) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    ativarOuInativarVendaSite = (e) => {
        const idItinerario = this.props.itinerario.id;
        const idEmpresa = this.props.itinerario.idEmpresa;
        if (e.target.value != 'false') {
            this.props.itinerarioChecked(idItinerario);
            $('#modalConfirmacaoInativacaoVendaSite').modal({
                show: true
            });
        } else {
            this.props.ativarVendaSite(idEmpresa, idItinerario)
                .then(() => {
                    this.props.buscarItinerarios();
                });
        }
    }

    exibeAtivoVendaSite = () => {
        return (
            <input type="checkbox" data-target="#modalConfirmacaoInativacaoVendaSite" value={this.props.itinerario.habilitadoSite} checked={this.props.itinerario.habilitadoSite} onChange={this.ativarOuInativarVendaSite} />
        );
    }

    exibirStatusVendaSite() {
        if (this.props.itinerario.habilitadoSite) {
            return (<span className="txt-ativo">Ativo</span>);
        }
        return (<span className="txt-inativo">Inativo</span>);
    }

    buscarLocalizacao() {
        this.props.buscarLocalizacaoVeiculo(this.props.itinerario.veiculoDto.id, this.props.itinerario.idEmpresa).then(() => {
            $('#modalLocalizacaoVeiculo')
                .modal('show');
        })
    }

    buscarPrecosRota() {
        if (tipoCategoria.mista.valor == this.props.itinerario.tipoCategoria) {            
            const tipoPrecos = this.retornaPrecosItinerarioMisto(this.props.itinerario);
            this.props.buscarPrecosRota(this.props.itinerario.idEmpresa, this.props.itinerario.rotaDto.id, tipoPrecos);
        } else {
            this.props.buscarPrecosRota(this.props.itinerario.idEmpresa, this.props.itinerario.rotaDto.id, [this.props.itinerario.tipoPreco.tipoPreco])
        }
    }

    retornaPrecosItinerarioMisto(itinerario) {
        const poltronas = itinerario.poltronas;
        const tipoPrecos = [...new Set(poltronas.map(it => it.tipoPreco))];
        return tipoPrecos;
    }

    categoriasItinerario(itinerario) {
        const tipoPrecos = this.retornaPrecosItinerarioMisto(itinerario);
        let tipos = '';
        tipoPrecos.forEach((it, index) => {
            const item = listaTipoPrecos.filter(l => l.id == it);            
            if (item && item.length > 0) {
                tipos += `${index > 0 ? ' | ' : ''} ${item[0].descricao}`
            }
        })
        return tipos
        
    }

    exibirIconeItinerarioMisto(itinerario) {
        return <> {this.props.itinerario.tipoCategoria} <span className="align-self-center tooltip-info">
            <a data-tip data-for={`categoria-${itinerario.id}`}>
                <i className="material-icons ajuda-icon" style={{ color: '#000' }}>&#xe147;</i>
            </a>
            <div className="tooltip-ut">
                <ReactTooltip className="tooltip-ut" id={`categoria-${itinerario.id}`}
                    type="dark" effect="solid">
                    <div className="row">{this.categoriasItinerario(itinerario)}</div>
                </ReactTooltip>
            </div>
        </span></>
    }

    naoEhPerfilVendedor() {
        return !validaPerfis([getVendedorAgencia(this.props.empresaSelecionada.id)])
    }

    exibirListaPassageiro() {
        if (!this.props.empresaSelecionada.habilitadoBloqueioListaPassageiro) {
            return (
                this.props.empresaSelecionada.id === EMPRESA_POLITUR ? <>
                            {this.naoEhPerfilVendedor() && 
                                <button type="button" className="btn btn-excluir "
                                title='Lista de passageiros'
                                onClick={() => this.props.history.push(`/painel-lista-passageiros?itinerario=${this.props.itinerario.id}${this.props.isEdicao ? '' : '&tipo=embarque'}`)}>
                                    <i className="material-icons nav-icon">&#xe637;</i>
                                </button>}
                        </>                                            
                    : <button type="button" className="btn btn-excluir "
                        title='Lista de passageiros'
                        onClick={() => this.props.history.push(`/painel-lista-passageiros?itinerario=${this.props.itinerario.id}${this.props.isEdicao ? '' : '&tipo=embarque'}`)}>
                        <i className="material-icons nav-icon">&#xe637;</i>
                    </button>);
        }

        return '';
    }

    render() { //teste
        return (
            <div className="geral">
                <div className="resumo">
                    <div className="row">
                        <div className="col">
                            <span className="titulo-mobile">Data/Hora saída:&nbsp;</span>
                            <Moment
                                format="DD/MM/YYYY">{this.props.itinerario.dataPartida}</Moment> às {this.props.itinerario.horaSaida}
                        </div>
                        <div className="col">
                            <span
                                className="titulo-mobile">Assentos:&nbsp;</span>{this.props.itinerario.assentosDisponiveis}
                        </div>

                        <div className="col mr-md-n2">
                            <span
                                className="titulo-mobile">Veiculo:&nbsp;</span>{this.props.itinerario.veiculoDto.descricao}
                        </div>
                        <div className="col mr-md-4">
                            <span className="titulo-mobile">Rota:&nbsp;</span>
                            {this.props.itinerario.rotaDto.cidadeOrigem.nome}-
                            {this.props.itinerario.rotaDto.cidadeOrigem.uf} à {this.props.itinerario.rotaDto.cidadeDestino.nome}-
                            {this.props.itinerario.rotaDto.cidadeDestino.uf}
                        </div>
                        <div className="col mr-md-4">
                            <span className="titulo-mobile">Prestador:&nbsp;</span>
                            {this.props.itinerario.prestador ? this.props.itinerario.prestador.valor : 'Frota própria'}
                        </div>
                        {this.props.empresaSelecionada.habilitadoSite ?
                            <div className="col ml-md-n4 mr-2">
                                <div className="botoes">
                                    <span className="titulo-mobile tm-status">Venda Site<br />Ativo/Inativo:&nbsp;</span>
                                    <div className="custom-btn-status exibeAtivo" htmlFor={this.props.itinerario.id}>
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.itinerario.idEmpresa),
                                            getGestorOperacoes(this.props.itinerario.idEmpresa),
                                            getAdminEmpresa(this.props.itinerario.idEmpresa),
                                            getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                            {this.exibeAtivoVendaSite()}
                                        </Autorizacao>
                                        {this.exibirStatusVendaSite()}
                                    </div>
                                </div>
                            </div> : ''
                        }
                        <div className="col mr-md-3">
                            <div className="botoes">
                                <span className="titulo-mobile tm-status">Categorias<br />&nbsp;</span>
                                {this.props.itinerario.tipoPreco ? this.props.itinerario.tipoPreco.descricaoTipoPreco: this.exibirIconeItinerarioMisto(this.props.itinerario)}
                            </div>
                        </div>
                        <div className="col">
                            <div className="botoes">
                                <span className="titulo-mobile tm-status">Itinerário<br />ativo/inativo:&nbsp;</span>
                                <div className="custom-btn-status exibeAtivo" htmlFor={this.props.itinerario.id}>
                                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                        getGestorEmpresa(this.props.itinerario.idEmpresa),
                                        getGestorOperacoes(this.props.itinerario.idEmpresa),
                                        getAdminEmpresa(this.props.itinerario.idEmpresa),
                                        getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                        {this.exibeAtivo()}
                                    </Autorizacao>
                                    {this.exibirStatus()}
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                getGestorEmpresa(this.props.itinerario.idEmpresa),
                                getGestorOperacoes(this.props.itinerario.idEmpresa),
                                getAdminEmpresa(this.props.itinerario.idEmpresa),
                                getOperadorEmpresa(this.props.itinerario.idEmpresa),
                                getFiscalEmbarque(this.props.itinerario.idEmpresa)]}>
                                {this.props.itinerario.sePodeEmbarcar ?
                                    <img style={{ cursor: 'pointer' }} title='Embarcar com QrCode'
                                        src={iconeQrCode}
                                        onClick={() => this.props.history.push('/painel-embarque-com-qrcode?itinerario=' + this.props.itinerario.id)} />
                                    : 'Fora do período de embarque'}
                            </Autorizacao>
                        </div>
                        <div id='container-botoes' className="col-sm-2 mr-md-n4">
                            <div className='dropdown'>
                                <span className="titulo-mobile">Ações:</span>
                                <button id='menu3pontos' className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="material-icons">
                                        &#xe5d4;
                                    </i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <div className="botoes">
                                        {<Autorizacao clasName="dropdown-item" perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.itinerario.idEmpresa),
                                            getGestorOperacoes(this.props.itinerario.idEmpresa),
                                            getAdminEmpresa(this.props.itinerario.idEmpresa),
                                            getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                            <button type="button" className="btn btn-editar "
                                                data-toggle="modal"
                                                title='Editar'
                                                data-target="#modalCadastrarItinerario"
                                                onClick={() => this.selecionarItinerario(this.props.itinerario)}>
                                                <i className="material-icons nav-icon">&#xe150;</i>
                                            </button>
                                        </Autorizacao>}
                                        {this.exibirListaPassageiro()}
                                        
                                            {<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                                getAdminEmpresa(this.props.itinerario.idEmpresa),
                                                getGestorOperacoes(this.props.itinerario.idEmpresa),
                                                getOperadorRemarcacao(this.props.itinerario.idEmpresa)]}>
                                                <img id='iconTransferencia' style={{ cursor: 'pointer' }} title='Transferir passageiros'
                                                    src={iconeTransferencia}
                                                    onClick={() => this.props.history.push(`/painel-transferencia-passageiros?itinerario=${this.props.itinerario.id}${this.props.isEdicao ? '' : '&tipo=embarque'}`)} />
                                            </Autorizacao>}
                                            
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.itinerario.idEmpresa),
                                            getGestorOperacoes(this.props.itinerario.idEmpresa),
                                            getAdminEmpresa(this.props.itinerario.idEmpresa),
                                            getOperadorEmpresa(this.props.itinerario.idEmpresa),
                                            getFiscalEmbarque(this.props.itinerario.idEmpresa),
                                            getMotoristaEmpresa(this.props.itinerario.idEmpresa)]}>                                            
                                            <Link to={`/painel-recibos-itinerario?empresa=${this.props.empresaSelecionada.id}&itinerario=${this.props.itinerario.id}${this.props.isEdicao ? '' : '&tipo=embarque'}`}
                                                target="_blank"
                                                title='Recibos do itinerário'
                                                className="btn btn-editar">
                                                <i className="material-icons nav-icon">&#xe638;</i>
                                            </Link>
                                        </Autorizacao>
                                        <button type="button" className="btn btn-excluir "
                                            title='Mapa de viagem'
                                            onClick={() => this.props.history.push(`/mapa-viagem-itinerario?itinerario=${this.props.itinerario.id}${this.props.isEdicao ? '' : '&tipo=embarque'}`)}>
                                            <i className="material-icons nav-icon">&#xe8d5;</i>
                                        </button>
                                        {this.props.empresaSelecionada.habilitadoBuscaReservaComBpe ? '' :
                                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                                getGestorEmpresa(this.props.itinerario.idEmpresa),
                                                getGestorOperacoes(this.props.itinerario.idEmpresa),
                                                getAdminEmpresa(this.props.itinerario.idEmpresa),
                                                getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                                <button type="button" className="btn btn-excluir "
                                                    title='Bloqueio de poltronas'
                                                    onClick={() => this.props.history.push(`/painel-bloqueio-poltronas?itinerario=${this.props.itinerario.id}`)}>
                                                    <i className="material-icons nav-icon">&#xe903;</i>
                                                </button>
                                            </Autorizacao>}
                                        {<Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.itinerario.idEmpresa),
                                            getGestorOperacoes(this.props.itinerario.idEmpresa),
                                            getAdminEmpresa(this.props.itinerario.idEmpresa),
                                            getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                            <button type="button" className="btn btn-editar "
                                                data-toggle="modal"
                                                title='Alterar veículo'
                                                data-target="#modalAlterarVeiculoItinerario"
                                                onClick={() => this.selecionarItinerarioAlterarVeiculo(this.props.itinerario)}>
                                                <i className="material-icons nav-icon">&#xe530;</i>
                                            </button>
                                        </Autorizacao>}
                                        {this.props.empresaSelecionada.habilitadoBuscaReservaComBpe ? '' :
                                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                                getGestorEmpresa(this.props.itinerario.idEmpresa),
                                                getAdminEmpresa(this.props.itinerario.idEmpresa),
                                                getMotoristaEmpresa(this.props.itinerario.idEmpresa),
                                                getFiscalEmbarque(this.props.itinerario.idEmpresa),
                                                getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                                <button type="button" className="btn btn-excluir "
                                                    title='Detalhamento Financeiro'
                                                    onClick={() => this.props.history.push(`/painel-detalhamento-financeiro-itinerario?itinerario=${this.props.itinerario.id}`)}>
                                                    <i className="material-icons nav-icon">&#xe263;</i>
                                                </button>
                                            </Autorizacao>}
                                        {this.props.itinerario.veiculoDto && this.props.itinerario.veiculoDto.idRastreamento ?
                                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                                getGestorEmpresa(this.props.itinerario.idEmpresa),
                                                getGestorOperacoes(this.props.itinerario.idEmpresa),
                                                getAdminEmpresa(this.props.itinerario.idEmpresa),
                                                getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                                <button type="button" className="btn btn-excluir "
                                                    title='Localização do itinerário'
                                                    onClick={() => this.buscarLocalizacao()}>
                                                    <i className="material-icons nav-icon">&#xe55b;</i>
                                                </button>
                                            </Autorizacao> : ''}
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.itinerario.idEmpresa),
                                            getGestorOperacoes(this.props.itinerario.idEmpresa),
                                            getAdminEmpresa(this.props.itinerario.idEmpresa),
                                            getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                            <button type="button" className="btn ml-2"
                                                data-toggle="modal"
                                                title='Relação de valores da rota'
                                                data-target="#modalPrecosRota"
                                                onClick={() => this.buscarPrecosRota()}>
                                                <img style={{ cursor: 'pointer' }} title='Preços'
                                                    src={iconeCash} />
                                            </button>
                                        </Autorizacao>
                                        {this.props.empresaSelecionada.habilitadoBuscaReservaComBpe ? '' :
                                            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                                getGestorEmpresa(this.props.itinerario.idEmpresa),
                                                getGestorOperacoes(this.props.itinerario.idEmpresa),
                                                getAdminEmpresa(this.props.itinerario.idEmpresa),
                                                getMotoristaEmpresa(this.props.itinerario.idEmpresa),
                                                getFiscalEmbarque(this.props.itinerario.idEmpresa),
                                                getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                                <button type="button" className="btn ml-2"
                                                    title='Painel financeiro encomenda'
                                                    onClick={() => {
                                                        this.selecionarItinerario(this.props.itinerario)
                                                        this.props.history.push(`/painel-detalhamento-financeiro-itinerario-Encomenda?itinerario=${this.props.itinerario.id}`)
                                                    }}>
                                                    <img id='icon-encomenda' style={{ cursor: 'pointer' }} title='Financeiro Encomenda' src={iconeEncomenda} />
                                                </button>
                                            </Autorizacao>}
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN, getGestorOperacoes(this.props.empresaSelecionada.id), getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                                            <Link to={`/painel-configuracao-reserva-bpe?codigoItinerario=${this.props.itinerario.id}&paginaRetorno=${this.props.paginaRetorno}`}
                                                className="btn btn-editar">
                                                <i className="material-icons nav-icon"
                                                    onClick={() => this.selecionarItinerario(this.props.itinerario)}>&#xe8a4;
                                                </i>
                                            </Link>
                                        </Autorizacao>
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                            getGestorEmpresa(this.props.itinerario.idEmpresa),
                                            getGestorOperacoes(this.props.itinerario.idEmpresa),
                                            getAdminEmpresa(this.props.itinerario.idEmpresa),
                                            getMotoristaEmpresa(this.props.itinerario.idEmpresa),
                                            getFiscalEmbarque(this.props.itinerario.idEmpresa),
                                            getOperadorEmpresa(this.props.itinerario.idEmpresa)]}>
                                            <button id='buttonExcluir' type="button" className="btn ml-2"
                                                title='Excluir itinerário'
                                                data-toggle="modal"
                                                data-target="#modalConfirmacaoExclusaoItinerario"
                                                onClick={() => this.selecionarItinerario(this.props.itinerario)}>
                                                <svg id='excluirItinerario' xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z" />
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z" />
                                                </svg>
                                            </button>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Buscar últimos Históricos Itinerário'
                                                    data-target="#modalHistoricoItinerario"
                                                    onClick={() => {                                                        
                                                        this.props.selecionarItinerario(this.props.itinerario);
                                                        this.props.buscarUltimosHistoricosItinerario(this.props.itinerario.id, this.props.empresaSelecionada.id);
                                                    }}>                                                
                                                <img src={iconAudoria} width={18} height={18} alt="Históricos Itinerário" />
                                            </button>
                                        </Autorizacao>
                                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                                                getAdminEmpresa(this.props.itinerario.idEmpresa),
                                                getGestorOperacoes(this.props.itinerario.idEmpresa),
                                                getOperadorRemarcacao(this.props.itinerario.idEmpresa)]}>
                                            <button type="button" className="btn ml-2"
                                                    data-toggle="modal"
                                                    title='Buscar Históricos Transferências Passageiros'
                                                    data-target="#modalHistoricoTransferenciaPassageiro"
                                                    onClick={() => {                                                        
                                                        this.props.selecionarItinerario(this.props.itinerario);
                                                        this.props.buscarHistoricosTransferenciaPassageiros(this.props.itinerario.id, this.props.empresaSelecionada.id);
                                                    }}>                                                
                                                <img src={iconHistoricoTransferencia} width={18} height={18} alt="Históricos Transferências Passageiros" />
                                            </button>
                                        </Autorizacao>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-2 mr-md-n4">
                            <span><b>ID Rota:</b>&nbsp;{this.props.itinerario.rotaDto.id}</span>
                        </div>
                        <div className="col-sm-2 mr-md-n4">
                            <span><b>ID Itinerário:</b>&nbsp;{this.props.itinerario.id}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        usuariosVendedores: state.usuariosVendedores,
    }
}

export default withRouter(connect(mapStateToProps, {
    changeFieldValue,
    selecionarItinerario,
    buscarReservasItinerario,
    buscarLocalizacaoVeiculo,
    ativarItinerario,
    buscarPrecosRota,
    selecionarRota,
    selecionarOrigem,
    selecionarDestino,
    ativarVendaSite,
    buscarUltimosHistoricosItinerario,
    buscarHistoricosTransferenciaPassageiros
})(reduxForm({
    form: 'formularioItinerario'
})(Itinerario)))
